import { render, staticRenderFns } from "./CustomerInvitationForm.vue?vue&type=template&id=f0909df8&scoped=true"
import script from "./CustomerInvitationForm.vue?vue&type=script&lang=js"
export * from "./CustomerInvitationForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvitationForm.vue?vue&type=style&index=0&id=f0909df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0909df8",
  null
  
)

export default component.exports